"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const types_1 = require("../../data/types");
const react_color_1 = require("react-color");
const SelectOption_1 = require("./SelectOption");
const SuccessorSelector_1 = __importDefault(require("./SuccessorSelector"));
const rc_slider_1 = __importDefault(require("rc-slider"));
require("rc-slider/assets/index.css");
const Row_1 = __importDefault(require("../layout/Row"));
class RuleEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            editing: true,
            editingColour: false
        };
    }
    render() {
        const { isRoot, rule, availableRules, updateOperation, updateScale, updateSuccessors, updateColour } = this.props;
        const otherRules = availableRules.filter(r => r !== rule.ruleKey);
        if (this.state.editing) {
            return (React.createElement("div", { className: "ruleEditor" },
                React.createElement(Row_1.default, null,
                    React.createElement("h1", { style: { flex: 1, margin: 0 } }, rule.ruleKey),
                    React.createElement("a", { className: "little-button", onClick: () => this.setState({ editing: false }) }, "Done Editing")),
                React.createElement("h3", null, isRoot ? "Start with" : "Operation"),
                isRoot ? (React.createElement(SelectOption_1.StartOperationSelectOption, { onChange: updateOperation, value: rule.operation })) : (React.createElement(SelectOption_1.OperationSelectOption, { onChange: updateOperation, value: rule.operation })),
                React.createElement("h3", null, "Rules to apply to faces"),
                React.createElement(SuccessorSelector_1.default, { onChange: updateSuccessors, availableRules: otherRules, successors: rule.successors }),
                React.createElement("h3", null,
                    "Scale (",
                    rule.scale,
                    ")"),
                React.createElement(rc_slider_1.default, { min: 0.1, max: 5.0, step: 0.01, onChange: updateScale, handleStyle: {
                        backgroundColor: "black",
                        border: 0,
                        borderRadius: 0
                    }, trackStyle: { backgroundColor: "orange" }, defaultValue: rule.scale }),
                React.createElement("h3", null, "Colour"),
                this.state.editingColour ? (React.createElement("span", { className: "little-button", onClick: () => this.setState({ editingColour: false }) }, "Done")) : (React.createElement("span", { className: "little-button", onClick: () => this.setState({ editingColour: true }) }, "Edit")),
                React.createElement("br", null),
                React.createElement("br", null),
                this.state.editingColour ? (React.createElement(react_color_1.ChromePicker, { disableAlpha: true, color: rule.colour, onChange: ({ hex }) => updateColour(hex) })) : (React.createElement("div", { style: {
                        backgroundColor: rule.colour,
                        width: 120,
                        height: 40,
                        border: "2px solid #222"
                    }, onClick: () => this.setState({ editingColour: true }) }))));
        }
        else {
            return (React.createElement("div", { className: "ruleEditor" },
                React.createElement(Row_1.default, null,
                    React.createElement("h1", { style: { flex: 1, margin: 0 } },
                        rule.ruleKey,
                        ": ",
                        types_1.nameForOperation[rule.operation]),
                    React.createElement("a", { className: "little-button", onClick: () => this.setState({ editing: true }) }, "Edit")),
                React.createElement(Summary, { rule: rule })));
        }
    }
}
exports.default = RuleEditor;
const Summary = ({ rule }) => {
    return (React.createElement("div", null,
        React.createElement("p", null,
            "Scale: ",
            rule.scale),
        React.createElement("div", { style: {
                backgroundColor: rule.colour,
                width: 60,
                height: 40,
                border: "2px solid #222"
            } }),
        React.createElement("p", null, types_1.describeSucessors(rule.successors))));
};



// WEBPACK FOOTER //
// ./src/components/editor/RuleEditor.tsx